// SDK do Chat da comunidade (Atendimento) — BFF /api/comunidade.
import { useEffect, useState } from 'react';
import { api } from './client';

export type AbaComunidade = 'decidir' | 'ocultas' | 'todas';
export type AcaoComunidade = 'manter' | 'liberar' | 'ocultar' | 'apagar';
export type MensagemComunidade = {
  id: number;
  autor_email: string;
  autor_nome: string | null;
  autor_plano: string | null;
  texto: string;
  criado_em: string;
  apagada_em: string | null;
  apagada_por: string | null;
  oculta: boolean;
  oculta_motivo: string | null;
  oculta_em: string | null;
  oculta_por: string | null;
  revisada_em: string | null;
  revisada_por: string | null;
  situacao: 'visivel' | 'oculta' | 'apagada';
  motivo: string | null;
  denuncias: { email: string; criado_em: string }[];
  para_decidir: boolean;
};
export type PaginaComunidade = { itens: MensagemComunidade[]; total: number; pagina: number; por_pagina: number };

export const comunidade = {
  listar: (aba: AbaComunidade, busca: string, pagina: number) =>
    api.get<PaginaComunidade>(`/api/comunidade?aba=${aba}&pagina=${pagina}${busca ? `&busca=${encodeURIComponent(busca)}` : ''}`),
  contagem: () => api.get<{ para_decidir: number }>('/api/comunidade/contagem'),
  decidir: (id: number, acao: AcaoComunidade) => api.post<unknown>(`/api/comunidade/${id}/${acao}`, {}),
};

// ── Contagem "para decidir" (badge do menu e card do Painel do atendimento) ────────────────────────────────────
// Uma consulta leve a cada 60 s (só com a aba visível). A tela do chat avisa depois de cada decisão
// (avisarContagemComunidade) e o badge atualiza na hora.
const EVENTO = 'comunidade:contagem';
export const avisarContagemComunidade = () => window.dispatchEvent(new Event(EVENTO));

export function useParaDecidirComunidade(ativo: boolean, intervaloMs = 60_000): number | null {
  const [n, setN] = useState<number | null>(null);
  useEffect(() => {
    if (!ativo) { setN(null); return; }
    let vivo = true;
    const buscar = () => {
      if (document.visibilityState === 'hidden') return;
      comunidade.contagem().then((r) => { if (vivo) setN(r.para_decidir); }).catch(() => undefined); // sem a migration 63 ou sem acesso: sem badge
    };
    buscar();
    const t = window.setInterval(buscar, intervaloMs);
    const aoVoltar = () => { if (document.visibilityState === 'visible') buscar(); };
    document.addEventListener('visibilitychange', aoVoltar);
    window.addEventListener(EVENTO, buscar);
    return () => { vivo = false; window.clearInterval(t); document.removeEventListener('visibilitychange', aoVoltar); window.removeEventListener(EVENTO, buscar); };
  }, [ativo, intervaloMs]);
  return n;
}
